import React, { forwardRef } from "react";
import Logo from "../../ui/logo/Logo";
import './Header.css';
import Menu from "../../ui/menu/Menu";
import ComponentWrapper from "../../utils/componentWrapper/ComponentWrapper";

const Header = forwardRef(({ open, setOpen }, ref) => {

    return (
        <header className="main-header" ref={ref}>
            <div className="background-wrapper">
                <div id="background"></div>
            </div>
            <div className="container header-wrapper">
                <div className="header-burger-menu">
                    <button onClick={ () => setOpen(!open) }>
                        <span />
                    </button>
                </div>
                {open && (
                    <Menu />
                )}
                <Logo />
                
                <ul className="header-list">
                    <li className="header-list-item"><a className="header-link" href="#internet"><p className="header-list-desc">Интернет</p></a></li>
                    <li className="header-list-item"><a className="header-link" href="#wifi"><p className="header-list-desc">Бесшовный WI-FI</p></a></li>
                    <li className="header-list-item"><a className="header-link" href="#phone"><p className="header-list-desc">Телефония</p></a></li>
                    <li className="header-list-item"><a className="header-link" href="#video"><p className="header-list-desc">Видеонаблюдение</p></a></li>
                </ul>
                <a className="header-number" type="tel" href="tel:+78124293993">(812) 429-3993</a>
            </div>
            
        </header>
    )
})

export default ComponentWrapper(Header);